import {LayoutType} from '../umpire-component-news';
import {Language} from '../umpire-language-service';

export enum UmpireClientName {
  ESA_ORG = 'Ekstraklasa',
  ESA_TV = 'Ekstraklasa_TV',
  LEGIA = 'Legia',
  LFF = 'Lithuanian FF',
}

export interface UmpireClientConfig {
  ott: UmpireOttConfig;
  contentLanguages: Language[];
  language: {
    content: Language[];
    interface: Language[];
  };
  // TODO unify speling from backend, cloud_front_id is incorrect.
  cloud_front_id?: string;
  cloudfront_id?: string;
  page_template: {
    match: {
      show_images: boolean;
    };
    news: {
      grid_types: LayoutType[];
    };
  };
  components: {
    gallery: {
      show_layout_options: boolean;
    };
  };
  incidents: Providable;
  lineups: Providable;
  standings: Providable;
  stats: Providable;
  tickets_match: Providable;
  tickets_season: Providable;
}

interface UmpireOttConfig {
  ads_enabled: boolean;
  /** Whether the tenant may offer pay-per-view formats (optional — older backends do not serve it). */
  ppv_enabled?: boolean;
  url: string;
  vod_audio_translation: boolean;
  stream: {
    default_blocked_country_codes: string[];
    start_automatically: boolean;
    start_encoding_before_minutes: number;
    srt_enabled: boolean;
  };
}

export interface UmpireClientConfigService {
  client: UmpireClientName | string;
  cloudFrontId: string;
  config: UmpireClientConfig | null;
  interfaceLanguages: Language[];
  init(): Promise<boolean>;
}

// Used for OTT client configuration on user's side
export interface UmpireCurrentClient {
  id: string;
  name: string;
  type: 'client';
  config: {
    external_dependencies: {
      bradmax: {
        analytics_token: string;
      };
      cloudfront_id: string;
      google: {
        tag: string;
      };
      system73: {
        token: string | null;
      };
      brndts: {
        api_key: string;
        auth_host: string;
      };
      cmp: {
        src: string;
      };
      wicket?: {
        application_id: string;
        application_sub: string;
        chargebee_item_familly_id: string;
        chargebee_site: string;
        frontend_url: string;
        images_url: string;
        url: string;
        wicket_apps: string;
      };
    };
    language: {
      default: string;
      available_languages: Language[];
    };
  };
}

// Fetched from AuthApI
export type AuthApiClient = {
  dns_name: string;
  name: string;
  type: 'client';
  config: {
    web: UmpireCurrentClient['config'];
  };
};

export interface Providable {
  provider: string;
}
